import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=ac0fad54&"
import script from "./Section.vue?vue&type=script&lang=js&"
export * from "./Section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac0fad54')) {
      api.createRecord('ac0fad54', component.options)
    } else {
      api.reload('ac0fad54', component.options)
    }
    module.hot.accept("./Section.vue?vue&type=template&id=ac0fad54&", function () {
      api.rerender('ac0fad54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/Section.vue"
export default component.exports